import {
	AutoReviewFailureMessage,
	AutoReviewSuccessMessage,
	CalculationCancelMessage,
	CalculationFailureMessage,
	CalculationInitiationMessage,
	CalculationSuccessMessage,
} from '../Types/Notifications.types';
import { fetchNotificationsByJobid, setNewNotification } from '../Slices/Notifications.slice';
import {
	handleGetStatusDetail,
	setTemporaryFailedCalculationNotificationStatusWidgetState,
	setTemporarySuccessfulCalculationNotificationStatusWidgetState,
} from '../../component/status-widget/statusWidget.slice';
import { AppDispatch, store } from '../../app/store';
import {
	handleSetRecentCompletedCalcRunState,
	setActiveCalculationId,
	setAutoReviewState,
	setCalculationInProgress,
	setCancelEnabled,
	setImportEnabled,
	setIsTestCaseRunInProgress,
} from '../../component/TopMenu/CalculationRun.slice';
import { Guid } from 'guid-typescript';
import { showErrorSnackbar, showSuccessSnackbar } from '../../component/snackbar/Snackbar.slice';
import { Messages } from '../../Constants/Messages';
import { UserFeatures } from '../Utils/UserFeatures';
import { setTestCaseStatus } from '../Slices/SanityCheck.slice';
import { TestCaseStatus } from '../Types/SanityCheck.types';

export function addCalculationSuccessNotification(
	calculationSuccessMessage: CalculationSuccessMessage,
	dispatch: AppDispatch,
	getState?: () => any,
) {
	dispatch(fetchNotificationsByJobid(calculationSuccessMessage.groupId));
	dispatch(handleSetRecentCompletedCalcRunState(Guid.parse(calculationSuccessMessage.groupId)));
	dispatch(
		setTemporarySuccessfulCalculationNotificationStatusWidgetState({
			hierarchyLevelId: Guid.parse(calculationSuccessMessage.groupId),
			currentlyWith: calculationSuccessMessage.startedBy,
			lastCalculationDate: new Date(calculationSuccessMessage.completedOn),
		}),
	);
	showSuccessSnackbar(dispatch, Messages.CALCULATIONS_SUCCEEDED);
	dispatch(setImportEnabled(true));
	dispatch(setNewNotification());
	dispatch(setCancelEnabled(false));
}

export function addCalculationFailureNotification(
	calculationFailureMessage: CalculationFailureMessage,
	dispatch: AppDispatch,
	getState?: () => any,
) {
	dispatch(fetchNotificationsByJobid(calculationFailureMessage.groupId));
	dispatch(handleSetRecentCompletedCalcRunState(Guid.parse(calculationFailureMessage.groupId)));
	dispatch(
		setTemporaryFailedCalculationNotificationStatusWidgetState({
			hierarchyLevelId: Guid.parse(calculationFailureMessage.groupId),
			currentlyWith: calculationFailureMessage.startedBy,
		}),
	);
	showErrorSnackbar(dispatch, Messages.CALCULATIONS_FAILED);
	dispatch(setImportEnabled(true));
	dispatch(setNewNotification());
	dispatch(setCancelEnabled(false));
	dispatch(setTestCaseStatus(TestCaseStatus.FailedCalculationError));
	dispatch(setIsTestCaseRunInProgress(false));
}

export function addCalculationInitiationNotification(
	calculationInitiationMessage: CalculationInitiationMessage,
	dispatch: AppDispatch,
	getState?: () => any,
) {
	dispatch(fetchNotificationsByJobid(calculationInitiationMessage.groupId));
	dispatch(setCalculationInProgress(true));
	dispatch(handleGetStatusDetail(Guid.parse(calculationInitiationMessage.groupId)));
	dispatch(setNewNotification());
}

export function addAutoReviewSuccessNotification(
	autoReviewSuccessMessage: AutoReviewSuccessMessage,
	dispatch: AppDispatch,
	getState?: () => any,
) {
	const userPermissions = getState?.()?.permission?.permissions;
	const hasViewAutoReviewReportsPermission = userPermissions?.application?.features?.includes(UserFeatures.VIEW_AUTO_REVIEW_REPORTS);
	dispatch(handleSetRecentCompletedCalcRunState(Guid.parse(autoReviewSuccessMessage.groupId)));
	dispatch(
		setAutoReviewState({
			autoReviewUrl: autoReviewSuccessMessage.reportLink,
			isSuccess: true,
		})
	);
	showSuccessSnackbar(dispatch, Messages.AUTO_REVIEW_SUCCESS);
	if (hasViewAutoReviewReportsPermission) {
		dispatch(setNewNotification());
	}
}

export function addAutoReviewFailureNotification(
	autoReviewFailureMessage: AutoReviewFailureMessage,
	dispatch: AppDispatch,
	getState?: () => any,
) {
	dispatch(handleSetRecentCompletedCalcRunState(Guid.parse(autoReviewFailureMessage.groupId)));
	const userPermissions = getState?.()?.permission?.permissions;
	const hasViewAutoReviewReportsPermission = userPermissions?.application?.features?.includes(UserFeatures.VIEW_AUTO_REVIEW_REPORTS);
	dispatch(
		setAutoReviewState({
			autoReviewUrl: '',
			isSuccess: false,
		})
	);
	showErrorSnackbar(dispatch, Messages.AUTO_REVIEW_FAILED);
	if (hasViewAutoReviewReportsPermission) {
		dispatch(setNewNotification());
	}
}


export function addCalculationCancelEnableNotification(
	calculationCancelMessage: CalculationCancelMessage,
	dispatch: AppDispatch,
) {
	const jobId = store.getState().cem.selectedJob.id;
	if (Guid.parse(calculationCancelMessage.groupId).equals(jobId)) {
		dispatch(setCancelEnabled(true));
		dispatch(setActiveCalculationId(Guid.parse(calculationCancelMessage.calculationId)));
	}
}

export function addCalculationCancelDisableNotification(
	calculationCancelMessage: CalculationCancelMessage,
	dispatch: AppDispatch,
) {
	const jobId = store.getState().cem.selectedJob.id;
	if (Guid.parse(calculationCancelMessage.groupId).equals(jobId)) {
		dispatch(setCancelEnabled(false));
	}
}

export function addCalculationCancelSuccessNotification(
	calculationCancelMessage: CalculationCancelMessage,
	dispatch: AppDispatch,
) {
	dispatch(fetchNotificationsByJobid(calculationCancelMessage.groupId));
	dispatch(handleSetRecentCompletedCalcRunState(Guid.parse(calculationCancelMessage.groupId)));
	dispatch(setCalculationInProgress(false));
	dispatch(setNewNotification());
}